var map = {
	"./AG.svg": 58,
	"./AI.svg": 59,
	"./AR.svg": 60,
	"./BE.svg": 61,
	"./BL.svg": 62,
	"./BS.svg": 63,
	"./FR.svg": 64,
	"./GE.svg": 65,
	"./GL.svg": 66,
	"./GR.svg": 67,
	"./JU.svg": 68,
	"./LU.svg": 69,
	"./NE.svg": 70,
	"./NW.svg": 71,
	"./OW.svg": 72,
	"./SG.svg": 73,
	"./SH.svg": 74,
	"./SO.svg": 75,
	"./SZ.svg": 76,
	"./TG.svg": 77,
	"./TI.svg": 78,
	"./UR.svg": 79,
	"./VD.svg": 80,
	"./VS.svg": 81,
	"./ZG.svg": 82,
	"./ZH.svg": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;